import sendToast from './sendToast';

const sendToastSyncError = () => {
  sendToast({
    type: 'error',
    message: 'Error syncing changes, please refresh the page!',
    duration: 4000
  });
};

export default sendToastSyncError;
